module.exports = __webpack_public_path__ + "img/demo-highlights.2c4a04ed.png";